
























import Vue from 'vue';
import Component from 'vue-class-component';
import store from 'store';
import vuex from '@/store';
import { User, Companies } from '@/store';

@Component({})
class CompaniesList extends Vue {
  @User.Action('fetchProjectsData') fetchProjectsData;
  @Companies.Mutation('setSelectedCompany') setSelectedCompany;

  // TypeScript workaround for v-hover scoped slot variable
  hover?: boolean;

  get companies(){
    const user = store.get('user');
    if (!user || !user.allowed_companies) return [];
    return Object.entries(user.allowed_companies);
  }

  chooseCompany(company_id: string) {
    const user = store.get('user');
    if (!user) return;
    store.set('user', {...user, company: company_id});
    this.setSelectedCompany(company_id);
    this.fetchProjectsData();
    
    this.$router.push('/projects');
  }
}

export default CompaniesList;
